import preval from "preval.macro";

export const FEBuildDate = preval`module.exports = new Date().toISOString();`;
export const FEVersion = 16;